import React, { useState, useEffect, useRef } from 'react';
import { ConfirmDialog } from './ConfirmDialog';
import { ProductAction } from '../../actions';
import { AppConfig, JWT } from '../../config';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { Translate as t } from '../../config/Translate';
import { resolveFileUrl } from '../../utils/filePreview';

export const S3DownloadButton = ({ text, css, path, filename, showtextfilename = false, tsg = false, directLink = null }) => {

	const [url, setUrl] = useState("");

	useEffect(() => {
		// Use directLink if provided, otherwise get URL from API
		if (directLink) {
			setUrl(directLink);
		} else if (filename && path) {
			getUrl();
		}
	}, [])

	useEffect(() => {
		// Use directLink if provided, otherwise get URL from API
		if (directLink) {
			setUrl(directLink);
		} else if (filename && path) {
			setUrl("");
			getUrl();
		}
	}, [filename, path, directLink])

	const getUrl = async () => {
		const apiPost = (body) => axios.post(AppConfig.API_SERVER_PATH + "/file/geturl", body, JWT());
		const u = await resolveFileUrl({ path, name: filename, directLink }, apiPost);
		if (u) setUrl(u);
	}

	return (
		<>
			{!tsg &&
				<>
					{url && <a href={url} target="_blank"
						style={{ fontSize: "12px" }}
						className={css}>{showtextfilename ? filename : text}</a>}
					{!url && filename}
				</>
			}
			{tsg &&
				<>
					{url && <a href={url} target="_blank"
						className={css}>{t('service.label.troubleshootingGuide')}
						{text > 0 &&
							<div className="chip chip-media ms-1">
								<i className="chip-icon bg-primary">
									<ion-icon name="thumbs-up-outline"></ion-icon>
								</i>
								<span className="chip-label">{text}</span>
							</div>
						}
					</a>}
					{!url && filename}
				</>
			}
		</>
	)
}

// 클릭 → 확인 대화상자(ConfirmDialog) → 확인 시 callback(item) 실행.
// confirmMsg 를 넘기면 대화상자 본문으로 사용, 생략 시 common.message.confirm.delete.
export const RayDelButton = ({ item, callback, startMsg = "delete", confirmMsg, css = "btn btn-danger" }) => {

	const [deleting, setDeleting] = useState(false);
	const [open, setOpen] = useState(false);
	const mounted = useRef(true);

	useEffect(() => {
		mounted.current = true;
		return () => { mounted.current = false; };
	}, []);

	const run = async () => {
		setDeleting(true);
		const ret = typeof callback === 'function' ? callback(item) : undefined;
		// 기존 동작 유지: 동기 callback 이면 비활성 상태 유지(중복 삭제 방지).
		// Promise 를 돌려주는 callback 만 끝난 뒤 복구한다(실패해 화면에 남은 경우 재시도 가능).
		if (ret && typeof ret.then === 'function') {
			try {
				await ret;
			} finally {
				if (mounted.current) setDeleting(false);
			}
		}
	}

	return <>
		<button
			type="button"
			disabled={deleting}
			className={css}
			onClick={() => setOpen(true)}>{deleting ? t('common.status.processing') : t(startMsg)}</button>
		{/* 포털 이벤트가 부모(카드·행 onClick)로 번지지 않게 차단 */}
		<span onClick={(e) => e.stopPropagation()}>
			<ConfirmDialog
				show={open}
				onClose={() => setOpen(false)}
				onConfirm={run}
				title={t('common.message.confirm.areYouSure')}
				message={confirmMsg || t('common.message.confirm.delete')}
				confirmLabel={t('common.button.delete')} />
		</span>
	</>
}

// 편집 진입([수정]) → 저장·취소 버튼 묶음. 상태(editing)와 동작은 부모가 갖는다. block: 가로를 꽉 채운 큰 버튼으로 세로 배치.
export const EditSaveCancelBar = ({ editing, onEdit, onSave, onCancel, saving = false, canEdit = true, saveLabelKey = 'common.button.save', className = '', block = false }) => {
	if (!canEdit) return null;
	if (block) {
		return (
			<div className={className}>
				{!editing &&
					<button type="button" className="btn btn-primary btn-block" onClick={() => onEdit && onEdit()}>{t('common.button.edit')}</button>
				}
				{editing &&
					<>
						<button type="button" className="btn btn-primary btn-block" disabled={saving} onClick={() => onSave && onSave()}>{t(saveLabelKey)}</button>
						<button type="button" className="btn btn-dark btn-block mt-1" onClick={() => onCancel && onCancel()}>{t('common.button.cancel')}</button>
					</>
				}
			</div>
		)
	}
	return (
		<span className={className}>
			{!editing &&
				<button type="button" className="btn btn-sm btn-primary" onClick={() => onEdit && onEdit()}>{t('common.button.edit')}</button>
			}
			{editing &&
				<>
					<button type="button" className="btn btn-sm btn-primary me-1" disabled={saving} onClick={() => onSave && onSave()}>{t(saveLabelKey)}</button>
					<button type="button" className="btn btn-sm btn-secondary" onClick={() => onCancel && onCancel()}>{t('common.button.cancel')}</button>
				</>
			}
		</span>
	)
}

export const EMSLogButton =({ item, product, css, showtextfilename = false }) => {

	const dispatch = useDispatch();

	const btnClick = () => {
		dispatch(ProductAction.RequestErrorLogFile(product.sn, item._id));
	}
	return (
		<>
			{item.emsreferKey && !item.emsrequestlog &&
				<button className={css}
					style={{ fontSize: "12px" }}
					onClick={() => btnClick()} > {t('service.label.requestLog')} </button>
			}
			{(item.emsrequestlog && !item.emsresponsetime) && <div>{t('common.status.requested')}</div>}
			{item.emslogpath &&
				<S3DownloadButton
					text={t('common.button.download')}
					showtextfilename={showtextfilename}
					style={{ fontSize: "12px" }}
					path={item.emslogpath}
					filename={item.emslogpath.replace(/^.*[\\\/]/, '')}
					css={css} />
			}
			{item.emsresponsefailreason && <div>{item.emsresponsefailreason}</div>}
		</>
	)
}